import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { Page } from '../../theme/components/Page'
import { PageSection } from '../../theme/components/PageSection'
import { StyledExpandCard } from '../../theme/components/StyledExpandCard'
import { AanvraagImporteren } from '../components/AanvraagImporteren'
import { AanvraagKopieren } from '../components/AanvraagKopieren'
import { AanvraagResetten } from '../components/AanvraagResetten'
import { Gebiedswissels } from '../components/Gebiedswissels'
import { JobScheduler } from '../components/JobScheduler'

export const Beheer = () => {
  const {
    canViewGebiedswissel,
    canViewAanvraagImporteren,
    canViewAanvraagKopieren,
    canCreateJobSchedule,
  } = useAuthenticatedUser()

  return (
    <Page
      title={['Beheer']}
      breadcrumbs={[
        { label: 'Home', href: '/home', tooltip: 'CAPO home' },
        { label: 'Beheer' },
      ]}
    >
      <PageSection id="beheer" heading="Beheer" />

      {canViewGebiedswissel && (
        <StyledExpandCard title="Gebied wisselen" collapsed>
          <Gebiedswissels />
        </StyledExpandCard>
      )}

      {canCreateJobSchedule && (
        <StyledExpandCard title="Job scheduler" collapsed>
          <JobScheduler />
        </StyledExpandCard>
      )}

      {canViewAanvraagImporteren && (
        <StyledExpandCard title="Aanvraag importeren" collapsed>
          <AanvraagImporteren />
        </StyledExpandCard>
      )}

      {canViewAanvraagKopieren && (
        <>
          <StyledExpandCard title="Aanvraag kopiëren" collapsed>
            <AanvraagKopieren />
          </StyledExpandCard>
          <StyledExpandCard title="Aanvraag resetten" collapsed>
            <AanvraagResetten />
          </StyledExpandCard>
        </>
      )}
    </Page>
  )
}
